import styled from "styled-components";
import { color } from "../../../../shared/styles";

export const ConversionRateWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 36px;
`;

export const ConversionRateText = styled.span<{ disabled?: boolean }>`
    font-size: 14px;
    color: #333;
    opacity: ${(props) => (props.disabled ? 0.7 : 1)};
`;

export const Input = styled.input<{ isError?: boolean }>`
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 6px 10px;
    margin: 0 8px;
    border: 1px solid ${(props) => (props.isError ? "#ff0000" : color.emphasis.NEUTRAL_N70)};
    border-radius: 5px;
    line-height: 24px;
    font-size: 13px;
    height: 36px;
    font-family: "Noto Sans";

    &:focus {
        outline: none;
        border-color: ${(props) => (props.isError ? "#ff0000" : color.primary.BLUE_B100)};
        box-shadow: 0 0 0 2px rgba(0, 88, 160, 0.12);
    }

    &::placeholder {
        color: ${color.secondary.DARK_GREY};
        font-size: 15px;
        font-style: normal;
        line-height: 22px;
        font-weight: 300;
    }

    &:disabled {
        opacity: 0.5;
    }
`;